if (!customElements.get('lf-serving-panel')) {
  customElements.define('lf-serving-panel', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || this.parentElement;
      this.variants = JSON.parse(this.querySelector('[data-serving-variants]').textContent);
      this.onChange = () => queueMicrotask(() => this.update());
      this.scope.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => this.update());
      }
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
    }
    update() {
      const form = this.scope.querySelector('product-form form[action*="/cart/add"]');
      const variant = this.variants.find(v => String(v.id) === form?.querySelector('[name="id"]')?.value);
      if (!variant) return;
      const subscription = this.scope.querySelector('[name="purchaseOption"]:checked')?.value === 'subscription';
      const option = this.scope.querySelector('.selling-plans:not(.selling-plan-hide) option:checked');
      let cents = subscription ? Number(option?.dataset.unitPrice) : Number(variant.price);
      // Existing quantity-tier offers subtract a per-can dollar amount.
      const tier = this.scope.querySelector('[name="tiered_pricing_option"]:checked');
      if (!subscription && tier) cents -= Number(tier.dataset.discount || 0) * 100;
      if (!Number.isFinite(cents) || cents < 0) return;
      const text = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency || 'USD'
      }).format(cents / (100 * Number(this.dataset.servings)));
      this.querySelector('[data-serving-cost]').textContent = text;
      this.querySelector('[data-serving-basis]').textContent = subscription ? 'with subscription' : 'one-time purchase';
    }
  });
}
